export default __webpack_public_path__ + "static/notice-icon-f2b606a927d931c3b4ace0f5664663b2.svg";